import * as React from "react";
import i18n from "i18n";
import classNames from "classnames";
import { Button, MenuItem, Tooltip, withStyles } from "@material-ui/core";
import {
  KeyboardArrowRight,
  KeyboardArrowDown,
  Autorenew as AutorenewIcon,
  Done as DoneIcon,
  Create as CreateIcon,
  Delete,
} from "@material-ui/icons";
import { Copy } from "common/icons";

interface IActionButtonProps {
  classes: any;
  hasAnyUpdate: boolean;
  hasAnyError: boolean;
  canInsertTakeOff: boolean;
  onClick: (
    type: "edit" | "delete" | "duplicate" | "insert" | "refresh"
  ) => void;
}

export const ActionButton = withStyles(() => ({
  icon: {
    fontSize: 20,
    opacity: 0,
    color: "#a8a8a8",
    marginRight: 7,
    marginTop: 7,
  },
}))(
  ({
    classes,
    hasAnyUpdate,
    hasAnyError,
    canInsertTakeOff,
    onClick = () => {},
  }: IActionButtonProps) => {
    if (hasAnyError)
      return (
        <Tooltip title={i18n.editto}>
          <CreateIcon
            className={classes.icon}
            onClick={() => onClick("edit")}
          />
        </Tooltip>
      );

    if (hasAnyUpdate)
      return (
        <Tooltip title={i18n.update}>
          <AutorenewIcon
            className={classes.icon}
            onClick={() => onClick("refresh")}
          />
        </Tooltip>
      );

    if (canInsertTakeOff)
      return (
        <Tooltip title={i18n.modelMaps.menuLateral.add}>
          <DoneIcon
            className={classes.icon}
            onClick={() => onClick("insert")}
          />
        </Tooltip>
      );

    return <></>;
  }
);

const styles = () => ({
  divider: { border: "1px solid #4E4E4E", margin: 3 },
  buttonContainer: {
    display: "inline-flex",
    outline: "none",
    width: "60%",
    justifyContent: "flex-start",
    paddingLeft: 8,
  },
  button: {
    font: "normal normal bold 9px/20px Raleway",
    color: "rgba(255, 255, 255, 0.6)",
    letterSpacing: 1,
    fontWeight: "400" as any,
    border: "1px solid #1D1D1D",
    background: "#272727",
    "&:hover": {
      background: "#353539",
    },
    borderRadius: 4,
    marginTop: 2,
    marginLeft: 3,
    padding: "2px 8px",
  },
  leftIcon: {
    marginRight: 5,
  },
  iconSmall: {
    fontSize: 15,
  },
  menuContainer: {
    display: "inline-flex",
    outline: "none",
    justifyContent: "flex-end",
  },
  menuItem: { padding: "0px 3px", margin: "0px 6px" },
});

export const ExpandedActionButtons = withStyles(styles)(
  ({
    classes,
    hasAnyUpdate,
    hasAnyError,
    canInsertTakeOff,
    onClick = () => {},
  }: IActionButtonProps) => {
    return (
      <div>
        <hr className={classes.divider}></hr>

        {hasAnyError ? (
          <div className={classes.buttonContainer}>
            <Button
              onClick={() => onClick("edit")}
              variant="outlined"
              className={classes.button}
              aria-owns={"simple-menu"}
              aria-haspopup="true"
            >
              <CreateIcon
                className={classNames(classes.leftIcon, classes.iconSmall)}
              />
              {i18n.correctErrors}
            </Button>
          </div>
        ) : hasAnyUpdate ? (
          <div className={classes.buttonContainer}>
            <Button
              onClick={() => onClick("refresh")}
              variant="outlined"
              className={classes.button}
              aria-owns={"simple-menu"}
              aria-haspopup="true"
            >
              <AutorenewIcon
                className={classNames(classes.leftIcon, classes.iconSmall)}
              />
              {i18n.update}
            </Button>
          </div>
        ) : (
          <></>
        )}

        <div
          className={classes.menuContainer}
          style={{
            width: hasAnyUpdate || hasAnyError ? "40%" : "100%",
          }}
        >
          <MenuItem
            className={classes.menuItem}
            onClick={() => onClick("delete")}
          >
            <Tooltip title={i18n.delete}>
              <Delete className={classes.iconSmall} />
            </Tooltip>
          </MenuItem>
          {!hasAnyError && (
            <MenuItem
              className={classes.menuItem}
              onClick={async () => onClick("duplicate")}
            >
              <Tooltip title={i18n.modelMaps.menuLateral.duplicate}>
                <Copy className={classes.iconSmall} />
              </Tooltip>
            </MenuItem>
          )}
          {!hasAnyError && (
            <MenuItem
              className={classes.menuItem}
              onClick={() => onClick("edit")}
            >
              <Tooltip title={i18n.editto}>
                <CreateIcon className={classes.iconSmall} />
              </Tooltip>
            </MenuItem>
          )}
          {!hasAnyUpdate && !hasAnyError && canInsertTakeOff && (
            <MenuItem
              className={classes.menuItem}
              onClick={() => onClick("insert")}
            >
              <Tooltip title={i18n.modelMaps.menuLateral.add}>
                <DoneIcon className={classes.iconSmall} />
              </Tooltip>
            </MenuItem>
          )}
        </div>
      </div>
    );
  }
);

export const ExpandButton = withStyles(() => ({
  icon: {
    padding: 0,
    background: "transparent",
    color: "#a8a8a8",
    height: "auto",
  },
}))(({ classes, expand, onChange }: any) => {
  if (expand)
    return (
      <KeyboardArrowDown
        className={classes.icon}
        aria-label="Mais"
        // aria-owns={open ? "long-menu" : undefined}
        aria-haspopup="true"
        onClick={() => onChange(false)}
      />
    );

  return (
    <KeyboardArrowRight
      className={classes.icon}
      aria-label="Menos"
      // aria-owns={open ? "long-menu" : undefined}
      aria-haspopup="true"
      onClick={() => {
        onChange(true);
      }}
    />
  );
});



// WEBPACK FOOTER //
// ./src/modules/modelMap/components/layouts/ModelMapItem/ActionButtons.tsx